import { customStyle } from 'styles/functions'

export const audioguideradiocanada = {
  body_background_color: '#fb4e3d',

  header_background_color: '#fb4e3d',
  header_padding: 40,

  logo_image_url: 'audioguideradiocanada.png',
  logo_height: 60,

  token_url: 'audioguideradiocanada.png',

  number_font: `'Poppins', sans-serif`,
  number_hidden_tokenIds: [0],

  button_color: '#0d57d2',
  button_border_width: 1,
  button_radius: 50,
  button_font: `'Radio Canada', serif`,

  custom_button_half: customStyle(`
    width: 400px;
    height: 200px;
    border-radius: 0;

    @media (max-width: 500px) {
      width: calc(100vw - 40px);
    }

    &::after {
      display: none;
    }
  `),
  custom_button_half_container: customStyle(`
    max-width: none;
  `),

  text_font: `'Radio Canada', serif`,
  title_font: `'Poppins', sans-serif`,

  footer_border_color: '#eee',

  custom_language_link: customStyle(`
    color: #FFF69C;
    position: absolute;
    top: 0;
    right: 0;
    background-color: black;
    padding: 8px 10px 5px 10px;
    font-weight: 600;
    transition: all 0.2s ease-in;

    &:hover {
      color: #0d57d2;
    }

    p {
      text-decoration: none !important;
    }
  `)
}

export const audioguideradiocanada_withoutnumbers = {
  ...audioguideradiocanada,
  card_header_margin_top: 30,
  token_hidden: true,
  number_hidden: true,
}
